import { PDF_CMA_REPORT, PDF_FULL_PROPERTY_PAGE, PDF_PROPERTY_PAGE } from '#/consts/url'

export const reportName = (type: TopHap.ReportType): string => {
  switch (type) {
    case 'CMA':
      return 'CMA Report'
    case 'PROPERTY_FULL':
      return 'Full Property Report'
    case 'PROPERTY_ONE_PAGE':
      return 'Property Report'
    // case 'ZMA':
    //   return 'ZMA'
    default:
      return 'Report'
  }
}

export const reportFrontUrl = (type: TopHap.ReportType, propertyId: string): string => {
  let pageUrl
  if (type === 'PROPERTY_FULL') {
    pageUrl = PDF_FULL_PROPERTY_PAGE
  } else if (type === 'PROPERTY_ONE_PAGE') {
    pageUrl = PDF_PROPERTY_PAGE
  } else {
    pageUrl = PDF_CMA_REPORT
  }
  return `${window.origin}${pageUrl.replace('[id]', propertyId)}`
}
